import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'
import type { DrawerProps } from '@mui/material/Drawer/Drawer'

export type DrawerViewOptions = {
  showAboveDialogs: boolean
  fullScreen: boolean
  anchor: DrawerProps['anchor']
  maxWidth: number
}

export const DRAWER_WIDTH = { default: 390, wide: 520 }

export const INITIAL_OPTIONS: DrawerViewOptions = {
  showAboveDialogs: false,
  fullScreen: false,
  anchor: 'right',
  maxWidth: DRAWER_WIDTH.default,
}

export type DrawerContextProps = {
  hasPreviousView: boolean
  isOpen: boolean
  openDrawer: (view: ReactNode, options?: Partial<DrawerViewOptions>) => void
  goBack: () => void
  goToRoot: () => void
  closeDrawer: () => void
  options: DrawerViewOptions
  setOptions: (options: Partial<DrawerViewOptions>) => void
}

const DrawerContext = createContext<DrawerContextProps>({
  hasPreviousView: false,
  isOpen: false,
  options: INITIAL_OPTIONS,
  openDrawer: () => undefined,
  goBack: () => undefined,
  goToRoot: () => undefined,
  closeDrawer: () => undefined,
  setOptions: () => undefined,
})

export const useDrawer = (): DrawerContextProps => {
  return useContext(DrawerContext)
}

export default DrawerContext
